import { getRegionByParentApi, getSquadListApi } from '@/api'

/**
 * 地区表单控件局部混入
 * 用于各界面的 el-cascader 地区组件
 * - `disableLevels` 和 `checkStrictly=false` 不能同时使用
 */
export default {
  data() {
    return {
      // 组件禁用层级，空表示不禁用
      disableLevels: [],
      // 组件最大层级，空表示全部展示，从 1 开始（省）
      maxLevel: null,
      // 组件配置项
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.lazyLoad
      },
    }
  },
  computed: {
    token() {
      return this.$store.getters.token
    },
    // 获取登录角色的地区
    getUserRegion() {
      // 目前是单角色，获取第一个即可
      const regions = this.$store.getters.user?.regions
      if (!regions || !regions.length) return null
      return regions[0]
    },
    // 地区编码
    getUserRegionCode() {
      let regionCode = this.getUserRegion?.regionCode
      // 补零
      if (regionCode) {
        regionCode = (regionCode + '000000000000').substring(0, 12)
      }
      return regionCode
    },
    // 地区名称
    getUserRegionName() {
      return this.getUserRegion?.regionName
    },
    // 地区级别
    getUserRegionLevel() {
      return this.getUserRegion?.regionLevel || 1
    },
  },
  methods: {
    // 组件懒加载
    async lazyLoad(node, resolve) {
      if (!this.token) return resolve(null)

      // 叶子节点，不需要再加载
      const leaf = node.data?.leaf
      if (leaf) return resolve(null)

      // 加载根节点
      if (node.root) {
        // 超级管理员没有地区编码，默认加载全部地区
        const isAdmin = !this.getUserRegionCode
        if (isAdmin) {
          const subRegions = await this.getSubRegions(null)
          const sortRegions = this.sortRegions(subRegions)
          return resolve(sortRegions)
        }
        // 其他角色默认第一个是自己
        return resolve([{
          label: this.getUserRegionName,
          value: this.getUserRegionCode,
          regionLevel: this.getUserRegionLevel,
          disabled: this.disableLevels.includes(this.getUserRegionLevel)
        }])
      }

      // 加载子节点
      // 如果当前的是村级，查的是屯组数据
      const interfaceName = node.data.regionLevel == 5 ? 'getGroupList' : 'getSubRegions'
      const subRegions = await this[interfaceName](node.value)
      resolve(subRegions)
    },

    /**
     * 调整地区位置
     * 超级管理员角色获取所有省，现在业务主要是广西，默认把广西放第一位，方便选择。（非强制需求，可以直接删除）
     * @returns 调整后的新数据
     */
    sortRegions(regions) {
      if (!regions.length) return []
      const gxRegionCode = '450000000000'
      const gxRegion = regions.find(item => item.value === gxRegionCode)
      if (gxRegion) {
        const othersRegions = regions.filter(item => item.value !== gxRegionCode)
        return [gxRegion, ...othersRegions]
      }
      return regions
    },

    // 获取下级地区列表
    async getSubRegions(parentCode) {
      let data = []
      try {
        const res = await getRegionByParentApi({ parentCode })
        if (res.code === 0 && res.data.length) {
          res.data.forEach(item => data.push({
            label: item.regionName,
            value: item.regionCode,
            regionLevel: item.regionLevel,
            parentRegionCode: item.parentRegionCode,
            // 当设置了最大展示层级时，设置该层级为叶子节点
            leaf: this.maxLevel && this.maxLevel == item.regionLevel,
            disabled: this.disableLevels.includes(item.regionLevel)
          }))
        }
      } finally {
        // eslint-disable-next-line
        return data
      }
    },

    // 获取屯组数据
    async getGroupList(parentCode) {
      let data = []
      try {
        const res = await getSquadListApi({
          pageIndex: 1,
          pageSize: 999,
          regionCode: parentCode,
        })
        if (res.code === 0 && res.data && res.data.items.length) {
          res.data.items.forEach(item => data.push({
            label: item.groupName,
            value: item.id,
            regionLevel: 6,
            leaf: true,
          }))
        }
      } finally {
        // eslint-disable-next-line
        return data
      }
    }
  }
}